<template>
  <v-main class="surfaceDim contenedor">
    <!-- Giras -->
    <v-row class="pa-0 ma-0" v-if="ruta === 'giras'">
      <v-col class="pa-0 ma-0 mb-4">
        <v-row class="pa-0 ma-0">
          <v-col cols="12" class="pa-0 ma-0">
            <v-row class="n10">
              <v-container>
                <!-- <v-breadcrumbs v-show="nom_evento" large dark class="white--text font-weight-bold align-items-start"
                  :items="items">
                  <template v-slot:item="{ item }">
                    <v-breadcrumbs-item :to="item.path" :disabled="item.disabled">
                      {{ item.text.toUpperCase() }}
                    </v-breadcrumbs-item>
                  </template>
                </v-breadcrumbs> -->
                <v-breadcrumbs v-show="nom_evento" dark aria-label="Ruta de navegación" large  class="font-weight-bold">
                 
                  <template>
                    <v-breadcrumbs-item  dark    class="onPrimary--text" to="/">
                      INICIO / GIRAS /
                    </v-breadcrumbs-item>
                    <v-breadcrumbs-item  dark    class="onPrimary--text">
                      {{ nom_evento }}
                    </v-breadcrumbs-item>
                  </template>
                </v-breadcrumbs> 

                <v-breadcrumbs v-show="nom_gira" dark aria-label="Ruta de navegación" large  class="font-weight-bold">
                 
                  <template>
                    <v-breadcrumbs-item  dark    class="primary--text" to="/">
                      INICIO / GIRAS /
                    </v-breadcrumbs-item>
                    <v-breadcrumbs-item  dark    class="onPrimary--text">
                      {{ nom_gira }}
                    </v-breadcrumbs-item>
                  </template>
                </v-breadcrumbs> 
                

                <!-- <v-breadcrumbs v-show="nom_gira" large dark
                  class="tertiaryFixedDim--text font-weight-bold align-items-start" :items="miga">
                  <template v-slot:item="{ item }">
                    <v-breadcrumbs-item :to="item.path" :disabled="item.disabled">
                      {{ item.text.toUpperCase() }}
                    </v-breadcrumbs-item>
                  </template>
                </v-breadcrumbs> -->
              </v-container>
            </v-row>
            <!-- Banner -->
            <v-container class="pa-0 mx-auto">
              <v-row class="pa-0 ma-0">
                <v-col class="pa-0 ma-0">
                  <v-img :src="imagen_gira" block contain> </v-img>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>

        <!-- Titulo Evento -->
        <v-row>
          <v-col class="ma-0 pa-0">
            <v-container>
              <v-row>
                <v-col>
                  <!-- Titulo -->
                  <h5 class="text-sm-h4 n10--text mb-0 font-weight-medium">
                    {{ nom_gira }}
                  </h5>
                  <!-- Fecha -->
                  <h6 class="text-sm-h5 n10--text text-capitalize text-md-headline">
                    {{ formatFecha(fecha_inicio) }}
                    -
                    {{ formatFecha(fecha_fin) }}
                  </h6>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>

        <!-- Tabs -->
        <v-col class="my-0 pa-0 pa-md-2">
          <v-card outlined class="mx-auto my-md-8 rounded-lg border" width="848">
            <v-col>
              <v-tabs class="px-4 mb-4">
                <v-tab class="primary--text" v-for="(item, index) in detalles" :key="index" v-show="index < 2">
                  <a class="nav-link d-flex text-md-subtitle-2 font-weight-medium onSurface--text text-uppercase"
                    :href="item.link"><v-icon left>
                      {{ item.icon }}
                    </v-icon>
                    <v-text class="d-none d-sm-none d-md-flex my-auto">
                      {{ item.tab }}</v-text>
                  </a>
                </v-tab>
              </v-tabs>

              <v-divider inset class="mt-n4 mx-8"></v-divider>
            </v-col>

            <v-tabs-items>
              <!-- Fechas -->

              <v-col class="mb-0 py-0">
                <!-- Titulo Sección Fechas -->

                <v-card-title id="fecha" class="d-inline text-md-h6 font-weight-light text-start text-h6 text-break">
                  <v-icon class="onSurface--text" left>
                    mdi-calendar-today
                  </v-icon>
                  Fechas
                </v-card-title>
                <v-divider></v-divider>
                <div class="container-fluid mx-0 px-0">
                  <router-link :to="{ name: 'evento', params: { evento: evento.slug } }"
                    v-for="(evento, index) in eventos" :key="index">
                    <v-card class="ma-md-4 pa-0 my-4 rounded-lg hover-card" min-width="300" max-width="776" outlined>
                      <v-row cols="12" md="8" class="mt-0 pa-0">
                        <!-- Avatar -->
                        <v-col cols="4" sm="3" md="4" class="pa-4 d-flex aling-center">
                          <v-img class="rounded-lg" :class="imageClass" :key="index"
                            v-for="(imagen, index) in evento.imagens" v-show="imagen.nombre.includes('miniatura_600')"
                            :src="imagen.url"></v-img>
                        </v-col>

                        <!-- Información  card-->
                        <v-col cols="8" sm="7" md="5" class="d-flex flex-column my-auto mx-0 px-0">
                          <v-card-title class="text-md-h6 text-start text-body-2 mb-1 text-break">
                            {{ evento.nombre }}
                          </v-card-title>
                          <v-card-subtitle class="text-start text-capitalize">
                            {{ formatFecha(evento.fecha_evento) }} |
                            {{ evento.nombreauditorio.toUpperCase() }}
                          </v-card-subtitle>
                        </v-col>
                        <v-spacer></v-spacer>

                        <!-- Boton Ticket -->
                        <v-col v-if="$vuetify.breakpoint.smAndUp" cols="1" md="2"
                          class="d-flex align-center justify-center px-0 pr-4 mx-0">
                          <router-link :to="{
                            name: 'evento',
                            params: { evento: evento.slug },
                          }">
                            <v-btn color="tertiary" dark fab text-color="onTertiary">
                              <v-icon class="px-0 mx-0">mdi-ticket</v-icon>
                            </v-btn>
                          </router-link>
                        </v-col>
                      </v-row>
                    </v-card>
                  </router-link>
                </div>
              </v-col>
              <!-- Información -->
              <v-col class="mt-0 pt-0">
                <v-card flat class="pa-0 my-2" id="informacion">
                  <!-- Titulo Sección Información -->
                  <v-card-title class="d-inline text-md-h6 font-weight-light text-start text-h6 text-break">
                    <v-icon class="onSurface--text" left>
                      mdi-information-outline
                    </v-icon>
                    Información
                  </v-card-title>
                  <v-card-text class="text-justify mt-4">
                    {{ informacion }}
                  </v-card-text>
                </v-card>
              </v-col>
            </v-tabs-items>
          </v-card>
        </v-col>
      </v-col>
    </v-row>

    <!--  Evento  -->
    <v-row v-if="ruta === 'eventos'" class="pa-0 ma-0">
      <v-col class="pa-0 ma-0 mb-4">
        <v-row class="pa-0 ma-0">
          <v-col cols="12" class="pa-0 ma-0">
            <v-row class="n10">
              <v-container>
                <v-breadcrumbs dark aria-label="Ruta de navegación" large  class="font-weight-bold">
                 
                  <template>
                    <v-breadcrumbs-item  dark    class="onPrimary--text" to="/">
                      INICIO / EVENTOS /
                    </v-breadcrumbs-item>
                    <v-breadcrumbs-item  dark    class="onPrimary--text">
                      {{ nom_evento }}
                    </v-breadcrumbs-item>
                  </template>
                </v-breadcrumbs> 
              </v-container>
            </v-row>

            <!-- Banner -->
            <v-layout>
              <picture class="cover d-flex justify-sm-center">
                <source media="(min-width: 2160px)" :srcset="getSrcSet({ width: 2160, name: 'banner_x2_2160' })" />
                <source media="(min-width: 1920px)" :srcset="getSrcSet({ width: 1920, name: 'banner_x2_1920' })" />
                <source media="(min-width: 1440px)" :srcset="getSrcSet({ width: 1440, name: 'banner_x1_1440' })" />
                <source media="(min-width: 1080px)" :srcset="getSrcSet({ width: 1080, name: 'banner_x1_1080' })" />
                <source media="(min-width: 720px)" :srcset="getSrcSet({ width: 720, name: 'banner_x1_960' })" />
                <source media="(min-width: 600px)" :srcset="getSrcSet({ width: 600, name: 'banner_x1_600' })" />

                <img :src="defaultImageUrl" class="responsive-img"
                  style="object-fit: contain; width: 100%; height: auto" :alt="`Banner del evento ${nom_evento}`" />
              </picture>
            </v-layout>
          </v-col>
        </v-row>

        <!-- Titulo Evento -->
        <v-row>
          <v-col class="ma-0 pa-0">
            <v-container>
              <v-row>
                <v-col>
                  <!-- Titulo -->
                  <h5 class="text-sm-h4 n10--text mb-0 font-weight-medium">
                    {{ nom_evento }}
                  </h5>
                  <!-- Fecha -->
                  <h6 class="text-sm-h5 n10--text text-capitalize text-md-headline">
                    {{ formatFecha(fecha_evento) }} | {{ lugar }}
                  </h6>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>

        <!-- Tabs -->
        <v-col class="my-0 pa-0 pa-md-2">
          <v-card class="mx-auto mt-md-5 border rounded-lg" width="848">
            <v-col class="mx-4 px-4">
              <v-tabs show-arrows class="px-4 mx-4">
                <v-tab v-for="item in filteredDetalles" :key="item.tab" @click="scrollTo(item.link)"
                  transition="scroll-y-transition" class="d-flex flex-column flex-md-row text-md-subtitle-2 font-weight-medium text-uppercase">
                  <v-icon left>{{ item.id == 'artista' ? id_tipo_evento == 10 ? 'mdi-basketball' : item.icon : item.icon }}</v-icon>
                  <span class="my-auto">
                    {{ item.id == 'artista' ? id_tipo_evento == 10 ? 'Equipos' : item.tab : item.tab }}
                  </span>
                </v-tab>
              </v-tabs>
              <v-divider inset class="mt-n4 mx-8"></v-divider>
            </v-col>
            <v-tabs-items>
              <!-- Fecha -->
              <v-col>
                <!-- Titulo Sección Fechas -->

                <v-card-title id="fecha" class="d-inline text-md-h6 font-weight-light text-start text-h6 text-break">
                  <v-icon class="onSurfaceVariant--text" left>
                    {{ getDetalleById('fecha').icon }}
                  </v-icon>
                  {{ getDetalleById('fecha').tab }}
                </v-card-title>
                <v-divider class="mb-4"></v-divider>
                <!-- Información Card -->
                <router-link :to="{ name: 'seleccionpuesto', params: { evento: slug } }">
                  <v-card id="fecha" class="ma-md-4 pa-0 hover-card" min-width="360" max-width="776" link outlined>
                    <v-row height="200" class="mt-0 px-2">
                      <!-- Avatar -->
                      <v-col cols="2" class="my-auto">
                        <v-text class="headline text-uppercase d-flex justify-center flex-wrap fill-height"
                          v-html="formatFechaCard(fecha_evento)">
                        </v-text>
                      </v-col>

                      <!-- Información -->
                      <v-col cols="7" class="d-flex flex-column my-auto">
                        <v-card-title class="text-sm-h5 text-start title mb-1 text-break pl-0">
                          {{ nom_evento }}
                        </v-card-title>
                        <v-card-subtitle class="text-start text-capitalize pl-0">
                          {{ lugar }}
                        </v-card-subtitle>
                      </v-col>
                      <v-spacer></v-spacer>
                      <!-- Boton Ticket Evento -->
                      <v-col cols="2" class="d-flex align-center justify-center pl-0">
                        <router-link :to="{
                          name: 'seleccionpuesto',
                          params: { evento: slug },
                        }" >
                          <v-btn text-color="onPrimary" color="primary" :large="$vuetify.breakpoint.mdAndUp" rounded
                            dark :fab="$vuetify.breakpoint.smAndDown" :aria-label="`Comprar entradas para el evento ${nom_evento}`">
                            <v-text class="mr-2" v-if="$vuetify.breakpoint.mdAndUp">
                              Comprar entradas
                            </v-text>

                            <v-icon> mdi-ticket </v-icon>
                          </v-btn>
                        </router-link>

                        <!--   Preventa -->
                        <v-btn v-if="preventa_exclusiva == 1" color="primaryContainer elevation-3  " dense fab
                          text-color="onPrimaryContainer">
                          <v-icon class="px-0 mx-0"> mdi-ticket </v-icon>
                        </v-btn>
                      </v-col>
                      <v-spacer></v-spacer>
                      <v-sheet v-if="preventa_exclusiva == 1" height="36" width="100%" block
                        class="black d-inline-flex">
                        <h6 class="onPrimary--text">Preventa Exclusiva</h6>
                        <v-spacer></v-spacer><v-icon dark> mdi-credit-card-check-outline</v-icon>
                      </v-sheet>
                    </v-row>
                  </v-card>
                </router-link>
              </v-col>
              <!-- Tab Información   -->
              <v-col>
                <!-- Titulo Sección Información -->
                 
                <v-card-title id="informacion"
                  class="d-inline text-md-h6 font-weight-light text-start text-h6 text-break">
                  <v-icon class="onSurfaceVariant--text text-md-h6" left>
                    {{ getDetalleById('informacion').icon }}
                  </v-icon>
                  {{ getDetalleById('informacion').tab }}
                </v-card-title>
                <v-divider></v-divider>

                <v-card flat>
                  <v-card class="mx-auto ma-4 pt-4" min-width="360" max-width="776" flat>
                    <v-row class="flex-column">
                      <v-col>
                        <v-card prepend-icon="mdi-github" flat>
                          <h6>
                            <b>Apertura de puertas: </b>{{ hora_apertura }}
                          </h6>
                          <h6><b>Horario inicio: </b>{{ hora_inicio }}</h6>
                          <h6>
                            <b>Horario de salida: </b>{{ hora_finalizacion }}
                          </h6>
                        </v-card>
                      </v-col>
                      <v-col cols="12">

                        <router-link :to="{
                          name: 'seleccionpuesto',
                          params: { evento: slug },
                        }">
                          <picture class="cover d-flex justify-sm-center">
                            <source media="(min-width: 1080px)" :srcset="getSrcSet({ width: 1080, name: 'mapa_desktop' })
                              " />
                            <img :src="getSrcSet({ width: 360, name: 'mapa_mobile' })
                              " class="responsive-img" :alt="`Mapa de puestos del evento ${nom_evento}`"
                               style="
                                object-fit: contain;
                                width: 100%;
                                height: auto;
                              "  />
                          </picture>
                        </router-link>
                        <picture class="cover d-flex justify-sm-center">                          
                          <source media="(min-width: 1080px)" :srcset="getSrcSet({ width: 1080, name: 'precios_desktop' })" />                          
                          <img :src="getSrcSet({ width: 360, name: 'precios_mobile' })"
                              class="responsive-img"
                              :alt="`Tabla de precios del evento ${nom_evento}`"
                              style="object-fit: contain; width: 100%; height: auto;" />
                        </picture>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-card>
              </v-col>
              <!-- Tab Puntos de venta  -->
              <v-col v-if="points != ''">
                <!-- Titulo Sección Puntos de Venta -->

                <v-card-title id="puntos" class="d-inline text-md-h6 font-weight-light text-start text-h6 text-break">
                  <v-icon class="onSurfaceVariant--text text-md-h6" left>
                    {{ getDetalleById('puntos').icon }}
                  </v-icon>
                  {{ getDetalleById('puntos').tab }}
                </v-card-title>
                <v-divider></v-divider>

                <v-card flat>
                  <v-card class="mx-auto ma-4 pt-4" min-width="360" max-width="776" flat>
                    <v-row class="flex-column">
                      <v-row>
                        <v-col v-for="point in points" :key="point.id" cols="12" md="6" class="d-flex">
                          <v-card outlined class="py-0 card-hover">
                            <v-card-text class="sidebar__point--text">
                              <article class="d-flex flex-column flex-nowrap">
                                <v-text class="title onSurface--text font-weight-bold text-capitalize mb-2">
                                  {{ point.nombre }}
                                </v-text>
                              </article>

                              <article>
                                <v-text class="caption text-capitalize">{{ point.descripcion }}
                                </v-text>
                                <br />
                                <v-text class="font-weight-light">
                                  {{ point.direccion }}
                                </v-text>
                                <br />

                                <v-text class="font-weight-light">
                                  {{ point.horario }} |
                                  {{ point.horario_atencion }}
                                </v-text>
                              </article>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-row>
                  </v-card>
                </v-card>
              </v-col>

              <!-- Tab Ubicación -->
              <v-col>
                <!-- Titulo Sección Ubicación -->

                <v-card-title id="ubicacion"
                  class="d-inline text-md-h6 font-weight-light text-start text-h6 text-break">
                  <v-icon class="onSurfaceVariant--text text-md-h6">
                    {{ getDetalleById('ubicacion').icon }}
                  </v-icon>
                  {{ lugar }}
                </v-card-title>
                <v-divider></v-divider>

                <v-card class="d-flex mx-auto ma-4 pt-4" flat>
                  <iframe :title="`Mapa interactivo de la ubicación de ${lugar}`" 
                  class="mx-4" 
                  width="100%" 
                  height="450" 
                  min-height="120" 
                  style="border: 0" 
                  loading="lazy"
                  allowfullscreen 
                  :src="'https://www.google.com/maps?q=' +
                      latitud +
                      ',' +
                      longitud +
                      '&hl=es;z=14&output=embed'
                      ">
                  </iframe>
                </v-card>
              </v-col>

              <!-- Tab Artista -->

              <v-card flat>
                <v-col>
                  <!-- Titulo Sección Artista -->

                  <v-card-title id="artista"
                    class="d-inline text-md-h6 font-weight-light text-start text-h6 text-break">
                    <v-icon class="onSurfaceVariant--text" left v-if="id_tipo_evento == 10">
                      mdi-basketball
                    </v-icon>
                    <v-icon class="onSurfaceVariant--text" left v-else>
                      {{ getDetalleById('artista').icon }}
                    </v-icon>
                    {{ id_tipo_evento == 10 ? 'Equipos' : getDetalleById('artista').tab  }}
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-container class="py-0">
                    <v-row class="py-0">
                      <v-col>
                        <v-card flat v-for="artist of artistas" :key="artist.id">
                          <div class="d-flex flex-column">
                            <v-card-title class="text-h5 font-weight-medium text-uppercase">{{ artist.nombre
                            }}</v-card-title>

                            <iframe v-if="artist.link_spotify" class="px-4 mb-4" style="border-radius: 12px"
                              :src="artist.link_spotify" width="100%" height="152" frameBorder="0" allowfullscreen=""
                              allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                              loading="lazy"></iframe>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-card>

              <!-- Terminos -->
              <v-col>
                <!-- Titulo Sección Terminos -->

                <v-card-title id="terminos" class="d-inline text-md-h6 font-weight-light text-start text-h6 text-break">
                  <v-icon class="onSurfaceVariant--text" left>
                    {{ getDetalleById('terminos').icon }}
                  </v-icon>
                  {{ getDetalleById('terminos').tab }}
                </v-card-title>
                <v-divider></v-divider>
                <!--Detalles  -->
                <v-col>
                  <v-card flat>
                    <v-card disable flat>
                      <v-text>
                        <h6><b>Codigo PULEP:</b> {{ codigo_pulep }}</h6>

                        <h6><b>Empresa Responsable:</b> {{ nom_cliente }}</h6>
                        <h6><b>Nit:</b> {{ cli_identificacion }}</h6>
                        <h6><b>Dirección:</b> {{ cli_direccion }}</h6>
                      </v-text>
                      <div class="mt-5">
                        <!-- Condiciones y Restricciones -->
                        <v-divider></v-divider>
                        <h6 class="mb-3 mt-5 font-weight-bold" style="text-align: left">
                          Condiciones y restricciones
                        </h6>
                        
                        <ul flat dense v-for="condicion in evento_data.condiciones">
                          <li>{{ condicion.descripcion }}</li>
                        </ul>
                        
                      </div>
                      <!-- Terminos y Condiciones de Uso -->
                      <v-divider></v-divider>
                      <h6 class="mt-5 font-weight-bold" style="text-align: left">
                        Terminos y Condiciones de Uso
                      </h6>
                      <v-card-text class="text-justify px-0 mx-0">
                        <p class="mb-0" :key="index" v-for="(p, index) in terminos.split('\n')">
                          <template v-if="p.split('•').length > 1">
                            <span :key="index2" v-for="(span, index2) in p.split('•')">{{ span.length > 1 ? '•' + span :
                              '' }}</span>
                          </template>
                          <template v-else>
                            <template v-if="p.split('\r').length > 1">
                              <span :key="index3" v-for="(span, index3) in p.split('\r')">{{ span.length > 1 ? span : ''
                              }}
                                <p v-if="span.length > 1" />
                              </span>
                            </template>
                            <template v-else>
                              {{ p }}
                            </template>
                          </template>
                        </p>
                      </v-card-text>
                    </v-card>
                  </v-card>
                </v-col>
              </v-col>
            </v-tabs-items>
          </v-card>

          <v-card> </v-card>
        </v-col>
      </v-col>
    </v-row>
    <div class="btn-help-container slide-bck-top-normal">
			
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="btn-help" href="/pqr" target="_blank" fab large dark color="tertiary" v-bind="attrs" v-on="on" aria-label="Centro de Ayuda">
            <v-icon large>mdi-face-agent</v-icon>
          </v-btn>
        </template>
        <span>Ayuda</span>
      </v-tooltip>
    
  </div>
  </v-main>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { configApi } from '../../api/configApi';
import { headers } from '../../api/headers';
export default {
  data() {
    return {
      points: '',
      fab: false,
      giranombre: null,
      heroImage: 'https://vuejs.org/images/logo.png',
      imagenesEventoBanner: 'null',
      currentRoute: window.location.pathname,
      ruta: null,
      scrollInvoked: 0,
      // Las resoluciones que necesitas
      tab: null,
      detalles: [
        {
          id: 'fecha',
          tab: 'Fecha',
          icon: 'mdi-calendar-today',
          link: '#fecha',
        },
        {
          id: 'informacion',
          tab: 'Información',
          icon: 'mdi-information-outline',
          link: '#informacion',
        },
        {
          id: 'puntos',
          tab: 'Puntos de Venta',
          icon: 'mdi-map-marker',
          link: '#puntos',
        },
        {
          id: 'ubicacion',
          tab: 'Ubicación',
          icon: 'mdi-map-outline',
          link: '#ubicacion',
        },
        {
          id: 'artista',
          tab: 'Artistas',
          icon: 'mdi-account-music-outline',
          link: '#artista',
        },
        {
          id: 'terminos',
          tab: 'Terminos y Condiciones',
          icon: 'mdi-file-document-outline',
          link: '#terminos',
        },
      ],
      condiciones:[]
    };
  },
  props: [
    'codigo_pulep',
    'nom_cliente',
    'cli_identificacion',
    'cli_direccion',
    'artistas',
    'artista',
    'terminos',
    'nom_evento',
    'lugar',
    'fecha_evento',
    'latitud',
    'longitud',
    'nom_artista',
    'imagen_evento',
    'evento_imagens',
    'eventos',
    'nom_gira',
    'fecha_inicio',
    'fecha_fin',
    'imagen_gira',
    'informacion',
    'hora_inicio',
    'hora_apertura',
    'hora_finalizacion',
    'miga',
    'items',
    'listcondiciones',
    'preventa_exclusiva',
    'slug',
    'imagen_mapa',
    'imagen_precio',
    'idevento',
    'id_tipo_evento',
    'evento_data'
  ],
  async beforeMount() {
    this.ruta = this.currentRoute.split('/');
    this.ruta = this.ruta[1];

    //console.log('llegue al detalle',this.listcondiciones);
    //console.log('estoy en el befere',this.idevento);
    await axios.get(`${configApi.apiUrl}condicionesevento/${this.idevento}`, null, { headers: headers })
        .then(response => {
          //console.log('estoy en el creatred',response);
          
          this.condiciones = response.data.data

          //console.log('guardo la respuets del detalle',this.condiciones);
          
        })
  },
  async created() {

    if (this.idevento != null) {
      await axios
        .get(
          `${configApi.apiUrl}ver_punto_ventas_mapa_evento/${this.idevento}`,
          null,
          { headers }
        )
        .then((response) => {
          this.points = response.data.data;
        });
    }
    
    
  },
  computed: {
    filteredDetalles() {

      return this.detalles.filter((item) => {
        // Verificamos si el tab es 'Puntos de Venta'
        if (item.tab === 'Puntos de Venta') {
          // Si 'points' está vacío (null, undefined, cadena vacía o solo espacios), excluimos el tab
          if (!this.points || this.points.trim() === '') {
            return false;
          }
        }
        // Incluimos todos los demás tabs y 'Puntos de Venta' si 'points' tiene información
        return true;
      });
    },
    defaultImageUrl() {
      // Busca la imagen por defecto (la de menor resolución o la primera disponible)
      const imagen = this.evento_imagens.find((imagen) =>
        imagen.nombre.includes('banner_x2_720')
      );
      return imagen ? imagen.url : '';
    },
  },
  methods: {
    scrollTo(selector) {
      const element = document.querySelector(selector);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    onScroll(e) {
      if (typeof window === 'undefined') return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    getDetalleById(id) {
      return this.detalles.find((item) => item.id === id) || {};
    },

    getSrcSet(resolucion) {
      // Buscar la imagen correspondiente a la resolución actual
      const imagen = this.evento_imagens.find((imagen) =>
        imagen.nombre.includes(resolucion.name)
        
      );
      // Si la imagen existe para esa resolución, devolver la URL, sino devolver una cadena vacía
      return imagen ? imagen.url : '';
    
    },
    formatFecha(fecha) {
      if (fecha != null && fecha != '') {
        return moment(fecha).format('LL');
      } else {
        return '';
      }
    },
    formatFechaCard(fecha) {
      if (fecha != null && fecha != '') {
        const formattedDate = moment(fecha).format('MMM D').replace('.', '');
        const [month, day] = formattedDate.split(' ');

        // Agregar un cero delante de los números de un solo dígito
        const formattedDay = day.length === 1 ? `0${day}` : day;

        return `${month}<span class="display-2 font-weight-bold">${formattedDay}</span>`;
      } else {
        return '';
      }
    },
    onScroll() {
      this.scrollInvoked++;
    },
  },
};
</script>

<style scoped>
.hover-card {
  transition: box-shadow 0.3s ease, transform 0.3s ease;
}

.hover-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-4px);
}

.hover-card:focus-within {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.tab__title-evento {
  font-family: 'Montserrat', 'Cabin', sans-serif !important;
  font-size: 1rem;
  font-weight: light;
}

.titulo_eventos {
  margin-top: 328px;
  margin-left: 0px;
}

html {
  scroll-behavior: smooth;
}



a {
  text-decoration: none;
}

</style>

<style>
#app > div > main > main > div > div.row.pa-0.ma-0 > div > div.row.pa-0.ma-0 > div > div.row.n10 > div > ul > li:nth-child(1) > a {
  color:#6ED2FF;
}

#app > div > main > main > div > div.row.pa-0.ma-0 > div > div.row.pa-0.ma-0 > div > div.row.n10 > div > ul > li:nth-child(3) > a {
  color:#6ED2FF;
}
</style>
